<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <span>Политика конфиденциальности</span>
        </h1>
        <bread-crumbs
            :navigation-data="[
                {name: 'Главная', route: 'main'},
                {name: 'Политика конфиденциальности', route: 'privacy_policy'},
            ]">
        </bread-crumbs>
      </div>



      <div class="page_content" v-html="htmlData"></div>



    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import BreadCrumbs from "@/components/share/BreadCrumbs";
import axios from "axios";



export default {
  name: 'PrivacyPolicyView',
  components: {
    BreadCrumbs,
    MainTemplate,
  },
  data() {
    return{
      htmlData: ""
    }
  },
  methods : {
    loadData : async function() {
      let res = await axios.get(window.api_url + "main/privacy_policy");

      this.htmlData = res.data;
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>


